var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{on:{"resetCrops":_vm.resetCrops,"updateTotals":_vm.updateTotals,"cropRemoved":_vm.removeCrop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }